import { TableHeader } from '@tiptap/extension-table'

export type { TableHeaderOptions } from '@tiptap/extension-table'
export { TableHeader } from '@tiptap/extension-table'

export default TableHeader
